import Flex from 'shared/ui/Flex'
import {
  CircleSkeleton,
  LinesSkeleton,
  Skeleton
} from 'shared/ui/Skeleton'

const PageSkeleton = () => {
  return (
    <Flex direction="column" rowGap={4}>
      <Skeleton width={134} height={190} radius={8} />
      <Flex justifyContent="space-between" alignItems="center">
        <CircleSkeleton size={12} marginLeft={4} />
        <LinesSkeleton
          marginLeft={18}
          lines={1}
          width={72}
          height={12}
        />
        <CircleSkeleton size={16} />
      </Flex>
    </Flex>
  )
}

export default PageSkeleton
